export default __webpack_public_path__ + "static/img/46.6ed99e2.png";